import { z } from "zod";

export const slotIdSchema = z.object({
  parentId: z.number(),
  name: z.string(),
  index: z.number().nonnegative().optional(),
});

export type SlotId = z.infer<typeof slotIdSchema>;
